require('./paymentWithDraftStep1.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');
// @ commons
const { InputSafe } = require('commonsComponents/inputSafe');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

// @components
const { AmountInput } = require('commonsComponents/amountInput');
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const OKModal = require('components/commons/OKModal/OKModal');

// @constants
const {
    DECLARATION_RESULT_TO_PAY,
    DECLARATION_RESULT_TO_GIVE_BACK,
    EURO_SYMBOL
} = require('constants/index');
const AMOUNT_RETURN_PLACEHOLDER = '0.000,00';

const differentialFeeImage = require('assets/images/fiscalidadyrenta_modal_2.png');
const justificativeImage = require('assets/images/fiscalidadyrenta_modal_1.png');


class PaymentWithDraftStep1 extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            justificative: props.immTaxAndRentsPaymentWithDraft.getIn(['steps', 0, 'justificative']),
            showModalDiferencialFee: false,
            showModalJustificative: false
        };

        this.handleBlurJustificative = this.handleBlurJustificative.bind(this);
        this.handleChangeJustificative = this.handleChangeJustificative.bind(this);
        this.handleChangeAmountReturn = this.handleChangeAmountReturn.bind(this);
        this.handleToggleShowModalDiferencialFee = this.handleToggleShowModalDiferencialFee.bind(this);
        this.handleToggleShowModalJustificative = this.handleToggleShowModalJustificative.bind(this);
        this.generateDifferentialFeeChangeHandler = this.generateDifferentialFeeChangeHandler.bind(this);
    }

    generateDifferentialFeeChangeHandler(bestBalanceAmount) {
        return (amount) => {
            this.props.setDifferentialFee(amount, bestBalanceAmount);
        }
    }

    handleChangeAmountReturn(value) {
        this.props.setAmountToReturn(value);
    }

    handleChangeJustificative(evt) {
        this.setState({
            justificative: evt.target.value
        });
    }

    handleBlurJustificative(evt) {
        this.props.setJustificative(evt.target.value);
    }

    handleToggleShowModalJustificative() {
        this.setState(previousState => ({
            showModalJustificative: !previousState.showModalJustificative
        }));
    }

    handleToggleShowModalDiferencialFee() {
        this.setState(previousState => ({
            showModalDiferencialFee: !previousState.showModalDiferencialFee
        }));
    }

    buildJustificativeModal() {
        const content = (
            <img
                alt=""
                className="payment-with-draft-step-one__modal-img"
                src={justificativeImage}
            />
        );

        return (
            <OKModal
                content={content}
                footerType="navigation"
                isOpen={this.state.showModalJustificative}
                onCloseCallback={this.handleToggleShowModalJustificative}
                onPrimaryButtonClick={this.handleToggleShowModalJustificative}
                primaryButtonText="common-accept"
                title="paymentWithDraft-justificativeModalTitle"
            />
        )
    }

    buildDifferentialFeeModal() {
        const content = (
            <img
                alt=""
                className="payment-with-draft-step-one__modal-img"
                src={differentialFeeImage}
            />
        );

        return (
            <OKModal
                content={content}
                footerType="navigation"
                isOpen={this.state.showModalDiferencialFee}
                onCloseCallback={this.handleToggleShowModalDiferencialFee}
                onPrimaryButtonClick={this.handleToggleShowModalDiferencialFee}
                primaryButtonText="common-accept"
                title="paymentWithDraft-diferencialFeeModalTitle"
            />
        );
    }

    render() {
        const { immTaxAndRentsPaymentWithDraft, immAccounts, immProfile, isInactiveAccountsEnabled, setFractionPayment, immLogin, setAccount, setDecalarationResult, setDomiciliateSecondPayment, setAmountToReturn } = this.props;
        const immStep = immTaxAndRentsPaymentWithDraft.getIn(['steps', 0]);
        const nameLabel = formatText('paymentWithDraft-name');
        const documentLabel = formatText('paymentWithDraft-document');
        const clientName = immProfile.get('nombreCliente') + ' ' + immProfile.getIn(['apellidoUno', 'apellido']) + ' ' + immProfile.getIn(['apellidoDos', 'apellido']);
        const clientDocument = immLogin.get('username');
        const justificativeAlertVisible = immStep.get('justificativeValidIsDirty') && !immStep.get('justificativeValid');
        const language = getLanguage();
        const isToGiveBackAccount = immStep.get('declarationResult') === DECLARATION_RESULT_TO_GIVE_BACK;
        const accountSelectionKey = 'paymentWithDraft-' + (isToGiveBackAccount ? 'accountSelectionToGiveBack' : 'accountSelectionToPay');
        let accountsDropdown, firstPaymentAmountBlock, domiciliateSecondPaymentBlock, feeBlock, fractionPaymentBlock, amountBlock, immFilteredAccounts;

        const accountsDropdownAlertVisible = immStep.get('accountIdIsDirty') && !(!!immStep.get('accountId'));
        const accountSelectionErrorTextKey = 'paymentWithDraft-' + (isToGiveBackAccount ? 'accountSelectionToGiveBackErrorMsg' : 'accountSelectionToPayErrorMsg');
        const differentialFeeModal = this.buildDifferentialFeeModal();
        const justificativeModal = this.buildJustificativeModal();
        let dropdownHint, filteredAccountIndexes, tooltipMsg;
        let hasEnoughBalanceAccounts = true;

        if (immStep.get('declarationResult') === DECLARATION_RESULT_TO_PAY) {
            const hasEnoughBalance = immAccount => {
                const balance = immAccount.getIn(['balances', 'availableBalance', 'amount']);
                if (immStep.get('fractionPayment')) {
                    return balance >= immStep.get('firstPayment');
                } else {
                    return balance >= immStep.get('differentialFee');
                }
            };

            dropdownHint = (
                <div className="payment-with-draft-step-one__help payment-with-draft-step-one__help--hint">
                    <i className="icon icon-informacion"></i>
                    <FormattedText value="paymentWithDraft-dropdownHint" />
                </div>
            );

            //filter first by CUENTA CORRIENTE and then compare amounts
            immFilteredAccounts = immAccounts.get('byId').filter(immAccount => immAccount.get('newProduct') === '300').filter(hasEnoughBalance);
            hasEnoughBalanceAccounts = immFilteredAccounts.size > 0;
            filteredAccountIndexes = immAccounts.get('byOrder').toJS().filter(id => !!immFilteredAccounts.get(id));
            tooltipMsg = isInactiveAccountsEnabled ? 'inactiveAccounts-inactiveAccounts_dropdownCommonToolTip' : '';
        } else {
            immFilteredAccounts = immAccounts.get('byId');
            filteredAccountIndexes = immAccounts.get('byOrder').toJS();
            tooltipMsg = isInactiveAccountsEnabled ? "inactiveAccounts-inactiveAccounts_consultiveDropdownCommonToolTip" : '';
        }

        const showErrorMsg = accountsDropdownAlertVisible && hasEnoughBalanceAccounts; // If the dropdown is not enabled don't show the error message

        accountsDropdown = (
            <div className="payment-with-draft-step-one__dropdown">
                <DropdownAccounts
                    id="paymentWithDraftAccount"
                    immAccounts={immFilteredAccounts}
                    accountsIndexes={filteredAccountIndexes}
                    currentAccountId={immStep.get('accountId')}
                    initialAccountId={immStep.get('accountId')}
                    onAccountChange={setAccount}
                    showAvailableBalance={true}
                    error={showErrorMsg}
                    errorMsg={formatText(accountSelectionErrorTextKey)}
                    label={accountSelectionKey}
                    showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    tooltipMsg={tooltipMsg}
                    optionalElement={dropdownHint}
                    enabled={hasEnoughBalanceAccounts}
                />
            </div>
        );

        if (immStep.get('declarationResult') === DECLARATION_RESULT_TO_GIVE_BACK) {
            const amountToReturnAlertVisible = immStep.get('amountToReturnIsDirty') && !immStep.get('amountToReturnValid');
            amountBlock = (
                <div>
                    <label className="payment-with-draft-step-one__label">
                        <FormattedText value="paymentWithDraft-amountToReturn" />
                        <i className="icon icon-informacion payment-with-draft-step-one__informative-icon" onClick={this.handleToggleShowModalDiferencialFee} />
                    </label>
                    <div className="payment-with-draft-step-one__input">
                        <AmountInput
                            id="paymentWithDraftAmountReturn"
                            min={0}
                            amount={immStep.get('amountToReturn')}
                            error={amountToReturnAlertVisible}
                            errorMsg={formatText('paymentWithDraft-amountToReturnErrorMessage', [
                                formatAmount(0)
                            ])}
                            placeHolder={AMOUNT_RETURN_PLACEHOLDER}
                            callback={setAmountToReturn}
                            showBlurZero
                            hideFocusZero
                            disablePaste
                            language={language}
                        />
                    </div>
                    <span className="payment-with-draft-step-one__currency-symbol">
                        {EURO_SYMBOL}
                    </span>
                </div>
            );
        } else {
            const immBalanceAccounts = immFilteredAccounts.size > 0 ? immFilteredAccounts : immAccounts.get('byId').filter(immAccount => immAccount.get('newProduct') === '300');
            const bestBalanceAmount = immBalanceAccounts.reduce((immAccountPrev, immAccountNext) =>
                immAccountPrev.getIn(['balances', 'availableBalance', 'amount']) > immAccountNext.getIn(['balances', 'availableBalance', 'amount'])
                    ? immAccountPrev
                    : immAccountNext)
                .getIn(['balances', 'availableBalance', 'amount']);

            const handleChangeDifferentialFee = this.generateDifferentialFeeChangeHandler(bestBalanceAmount);
            const differentialFeeAlertVisible = immStep.get('differentialFeeValidIsDirty') && !hasEnoughBalanceAccounts;
            feeBlock = (
                <div>
                    <label className="payment-with-draft-step-one__label">
                        <FormattedText value="paymentWithDraft-differentialFee" />
                        <i className="icon icon-informacion payment-with-draft-step-one__informative-icon" onClick={this.handleToggleShowModalDiferencialFee} />
                    </label>
                    <div className="payment-with-draft-step-one__input">
                        <AmountInput
                            id="paymentWithDraftDifferentialFee"
                            min={0}
                            amount={immStep.get('differentialFee')}
                            callback={handleChangeDifferentialFee}
                            error={differentialFeeAlertVisible}
                            errorMsg={formatText('paymentWithDraft-differentialFeeSuperiorThanAnyAccount')}
                            showBlurZero
                            hideFocusZero
                            disablePaste
                            language={language}
                        />
                    </div>
                    <span className="payment-with-draft-step-one__currency-symbol">
                        {EURO_SYMBOL}
                    </span>
                </div>
            );

            fractionPaymentBlock = (
                <div>
                    <label className="payment-with-draft-step-one__label">
                        <FormattedText value="paymentWithDraft-fractionPayment" />
                    </label>
                    <RadioButtonGroup
                        name="fractionPayment"
                        idPrefix="paymentWithDraftFractionPayment"
                        selectedValue={immStep.get('fractionPayment')}
                        onChange={setFractionPayment}
                        className="account-cancel-chequebook-step__radio-group"
                    >
                        <RadioButton
                            label={formatText('paymentWithDraft-yes')}
                            value={true}
                            className="payment-with-draft-step-one__radio"
                        />
                        <RadioButton
                            label={formatText('paymentWithDraft-no')}
                            value={false}
                            className="payment-with-draft-step-one__radio"
                        />
                    </RadioButtonGroup>
                </div>
            );
        }

        if (immStep.get('fractionPayment') && immStep.get('declarationResult') !== DECLARATION_RESULT_TO_GIVE_BACK) {
            const firstPaymentAmountFormatted = formatAmount(immStep.get('firstPayment'));

            firstPaymentAmountBlock = (
                <div className="payment-with-draft-step-one__message">
                    <label className="payment-with-draft-step-one__label--secondary">
                        <FormattedText value="paymentWithDraft-firstPaymentAmount" />
                    </label>
                    <div className="payment-with-draft-step-one__amount">
                        {firstPaymentAmountFormatted} {EURO_SYMBOL}
                    </div>
                    <span className="payment-with-draft-step-one__help">
                        <FormattedText value="paymentWithDraft-firstPaymentAmountHelp" />
                    </span>
                </div>
            );

            domiciliateSecondPaymentBlock = (
                <div className="col-xs-12">
                    <label className="payment-with-draft-step-one__label">
                        <FormattedText value="paymentWithDraft-domiciliateSecondPayment" />
                    </label>
                    <RadioButtonGroup
                        name="domiciliateSecondPayment"
                        idPrefix="paymentWithDraftDomiciliateSecondPayment"
                        selectedValue={immStep.get('domiciliateSecondPayment')}
                        onChange={setDomiciliateSecondPayment}
                        className="account-cancel-chequebook-step__radio-group"
                    >
                        <RadioButton
                            label={formatText('paymentWithDraft-yes')}
                            value={true}
                            className="payment-with-draft-step-one__radio"
                        />
                        <RadioButton
                            label={formatText('paymentWithDraft-no')}
                            value={false}
                            className="payment-with-draft-step-one__radio"
                        />
                    </RadioButtonGroup>
                </div>
            );
        }

        return (
            <section className="payment-with-draft-step-one">
                {differentialFeeModal}
                {justificativeModal}
                <article className="payment-with-draft-step-one__section">
                    <header className="payment-with-draft-step-one__header">
                        <FormattedText
                            value="paymentWithDraft-paymentData"
                            className="payment-with-draft-step-one__title"
                        />
                    </header>
                    <section className="payment-with-draft-step-one__content">
                        <OKInformativeList columns={2}>
                            <OKInformativeListItem
                                title={nameLabel}
                                bodyText={clientName}
                                bodyWordBreak={false}
                            />
                            <OKInformativeListItem
                                title={documentLabel}
                                bodyText={clientDocument}
                            />
                        </OKInformativeList>
                    </section>
                </article>

                <article className="payment-with-draft-step-one__section">
                    <section className="payment-with-draft-step-one__content">
                        <div className="row payment-with-draft-step-one__subsection">
                            <div className="col-xs-5">
                                <label className="payment-with-draft-step-one__label">
                                    <FormattedText value="paymentWithDraft-justificative" />
                                    <i className="icon icon-informacion payment-with-draft-step-one__informative-icon" onClick={this.handleToggleShowModalJustificative} />
                                </label>
                                <InputSafe
                                    type="text"
                                    name="justificative"
                                    id="paymentWithDraftJustifcative"
                                    value={this.state.justificative}
                                    maxLength="13"
                                    onChange={this.handleChangeJustificative}
                                    onBlur={this.handleBlurJustificative}
                                    errorState={justificativeAlertVisible}
                                    errorMessage={formatText('paymentWithDraft-justificativeError')}
                                />
                            </div>
                        </div>
                        <div className="row payment-with-draft-step-one__subsection">
                            <div className="col-xs-12">
                                <label className="payment-with-draft-step-one__label">
                                    <FormattedText value="paymentWithDraft-declarationResult" />
                                </label>
                                <RadioButtonGroup
                                    name="declarationResult"
                                    idPrefix="paymentWithDraftDeclarationResult"
                                    selectedValue={immStep.get('declarationResult')}
                                    onChange={setDecalarationResult}
                                    className="account-cancel-chequebook-step__radio-group"
                                >
                                    <RadioButton
                                        label={formatText('paymentWithDraft-toPay')}
                                        value={DECLARATION_RESULT_TO_PAY}
                                        className="payment-with-draft-step-one__radio"
                                    />
                                    <RadioButton
                                        label={formatText('paymentWithDraft-toGiveBack')}
                                        value={DECLARATION_RESULT_TO_GIVE_BACK}
                                        className="payment-with-draft-step-one__radio"
                                    />
                                </RadioButtonGroup>
                            </div>
                        </div>
                        <div className="row payment-with-draft-step-one__subsection">
                            <div className="col-xs-12">
                                {amountBlock}
                                {feeBlock}
                            </div>
                        </div>
                        <div className="row payment-with-draft-step-one__subsection">
                            <div className="col-xs-6">
                                {fractionPaymentBlock}
                            </div>
                            <div className="col-xs-6">
                                {firstPaymentAmountBlock}
                            </div>
                        </div>
                        <div className="row payment-with-draft-step-one__subsection">
                            {domiciliateSecondPaymentBlock}
                        </div>
                    </section>
                </article>
                <article className="payment-with-draft-step-one__section">
                    <section className="payment-with-draft-step-one__content">
                        <div className="payment-with-draft-step-one__subsection">
                            {accountsDropdown}
                        </div>
                    </section>
                </article>
            </section>
        )
    }
}

PaymentWithDraftStep1.propTypes = {
    immTaxAndRentsPaymentWithDraft: PropTypes.object,
    immAccounts: PropTypes.object,
    immProfile: PropTypes.object,
    immLogin: PropTypes.object,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    setDomiciliateSecondPayment: PropTypes.func,
    setDifferentialFee: PropTypes.func,
    setFractionPayment: PropTypes.func,
    setJustificative: PropTypes.func,
    setDecalarationResult: PropTypes.func,
    setAmountToReturn: PropTypes.func,
    setAccount: PropTypes.func
};

module.exports = PaymentWithDraftStep1;
